import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Modal, Select, Spin } from "antd";
import "./charge.scss";
import { useEffect, useRef, useState } from "react";
import { commaDigits, convertCurrencyToRial, convertCurrencyToToman, convertToJalaliWithTime, delay, isEmpty } from "../../../tools/tools";
import { useTranslation } from "react-i18next";
import { useAPIPublic, useSecurity } from "../../../tools/api";
import { useDispatch, useSelector } from "react-redux";
import { globalValue } from "../../../reducer/serviceReducerGlobala";
import Loading from "../loader/loading";
import { Roles } from "../../../tools/services";

const IncressCharge = ({ callback, open, msisdn, planid, price, localInvoiceId = "", activePrice = false, behpardakht = {} }) => {
	const [disInput, setDisInput] = useState(true);
	const [statusOpen, setStatusOpen] = useState(open || false);
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	const { queryWalletType } = useAPIPublic();
	const { queryGateWayByPlanId, increaseWalletByBankGateWay, callBackIPGAsanPardakht, callBackPOSAsanPardakht, CallBackMellat } = useSecurity();
	const { queryCurrentUser, queryUserRoles } = useAPIPublic();
	const [t] = useTranslation("global");
	const [listWallet, setListWallet] = useState([]);
	const [chargeAmount, setChargeAmount] = useState();
	const [bankId, setBankId] = useState(0);
	const [bankList, setBankList] = useState([]);
	const [frmCharge] = Form.useForm();
	const [isCallBack, setIsCallback] = useState(false);
	const [floLocalInvoiceId, setFloLocalInvoiceId] = useState("");
	const [bankMessage, setBankMessage] = useState();
	const [bankTitle, setBankTitle] = useState();
	const [isLoading, setIsLoading] = useState(false);

	const [inPayment, setInPayment] = useState(false);

	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});

	const timerRef = useRef(null);
	const intervalRef = useRef(null);
	const stopTimerRef = useRef(null);

	useEffect(() => {
		if (open) {
			setStatusOpen(open);
			if (isEmpty(localInvoiceId) && isEmpty(behpardakht?.RefId)) {
				handleLoadWalletType();
				handleGetWay();
				setIsCallback(false);
			} else if (behpardakht?.RefId) {
				setIsCallback(true);
				handleCallBankMellat();
			} else {
				setIsCallback(true);
				setFloLocalInvoiceId(localInvoiceId);
				handelCallBankBank(localInvoiceId);
			}
		}
	}, [open]);

	useEffect(() => {
		setChargeAmount(price);
		frmCharge.setFieldValue("charge", commaDigits(convertCurrencyToToman(price)));
	}, [price]);
	const handleComma = (e) => {
		let v = e.target.value;
		if (e.target.value.length > 0 && !isNaN(parseInt(e.target.value))) {
			v = commaDigits(parseInt(e.target.value.replace(/,/g, "")) / 1);
			e.target.value = v;
			return v;
		} else {
			return "";
		}
	};
	const handleSubmit = async (value) => {
		if (value.WalletType) {
			let payload = {
				Amount: convertCurrencyToRial(value.charge.replace(/,/g, "")),
				PlanId: planid,
				WalletType: value.WalletType,
				BnakId: value?.getway || bankId,
			};
			let response = await increaseWalletByBankGateWay(payload);
			if (response?.includes("html") || response?.includes("form")) {
				if (value?.getway) {
					const bankpos = bankList.find((bank) => bank.bankId == value?.getway);
					if (bankpos?.bankType == 8) {
					} else {
						callback(response);
					}
				} else {
					callback(response);
				}

				// bankRef.current.innerHTML = "";
				// document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
			} else if (response) {
				setInPayment(true);
				handleServicePayment(response);
			}
		} else {
			handleLoadWalletType();
		}
	};
	const handleServicePayment = async (invoice) => {
		const payload = { InvoiceNumber: invoice };

		const fetchAndCheckResponse = async () => {
			const response = await callBackPOSAsanPardakht(payload);
			if (response) {
				setIsCallback(true);
				setFloLocalInvoiceId(response?.Result?.followupcode);
				setBankTitle("پرداخت موفق");
				setBankMessage(response?.Message);
				await delay(3000);
				let _currentUser = await queryCurrentUser();
				if (_currentUser) {
					let resRoles = await queryUserRoles();
					if (resRoles) {
						dispatch(globalValue({ _currentUser: { ..._currentUser, roles: [...resRoles] } }));
					}
				}
				setInPayment(false);
				stopServiceCall();
			} else {
				setFloLocalInvoiceId(invoice);
				setBankMessage(response?.Message);
			}
		};

		timerRef.current = setTimeout(async () => {
			await fetchAndCheckResponse();

			intervalRef.current = setInterval(fetchAndCheckResponse, 10000);
		}, 20000);

		stopTimerRef.current = setTimeout(() => {
			setIsCallback(true);
			setBankTitle("پرداخت موفق");
			stopServiceCall();
			setInPayment(false);
		}, 2 * 60 * 1000);
	};
	const stopServiceCall = () => {
		clearTimeout(timerRef.current);
		clearInterval(intervalRef.current);
		clearTimeout(stopTimerRef.current);
	};
	const handleLoadWalletType = async () => {
		try {
			setIsLoading(true);
			setInPayment(true);
			let response = await queryWalletType();
			if (response) {
				let resWallet = [];
				_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessCC) && resWallet.push(response?.find((item) => item.value === 2));
				_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessCP) && resWallet.push(response?.find((item) => item.value === 3));
				_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessOtherSales) && resWallet.push(response?.find((item) => item.value === 1));
				_currentUser?.roles?.includes(Roles.Dealer_Wallet_AccessAsanWallet) && resWallet.push(response?.find((item) => item.value === 4));

				if (resWallet.length == 1) {
					frmCharge.setFieldValue("WalletType", resWallet[0].value);
				} else {
					setListWallet(resWallet);
				}
			}
			setIsLoading(false);
			setInPayment(false);
		} catch (error) {
			setIsLoading(false);
			setInPayment(false);
		}
	};
	const handleGetWay = async () => {
		setIsLoading(true);
		setInPayment(true);
		let payload = {
			msisdn: msisdn,
			planid: planid,
		};
		let response = await queryGateWayByPlanId(payload);
		if (response) {
			if (response.length > 1) {
				setBankList(response);
			} else {
				setBankId(response[0]?.bankId);
			}
		}
		setInPayment(false);
		setIsLoading(false);
	};
	const handelCallBankBank = async (LocalInvoiceId) => {
		setIsLoading(true);
		let payload = {
			LocalInvoiceId: LocalInvoiceId,
		};
		let response = await callBackIPGAsanPardakht(payload);
		if (response && !response?.HasError) {
			setFloLocalInvoiceId(response?.Result?.followupcode);
			setBankTitle("پرداخت موفق");
			setBankMessage(response?.Message);
			await delay(3000);
			let _currentUser = await queryCurrentUser();
			if (_currentUser) {
				let resRoles = await queryUserRoles();
				if (resRoles) {
					dispatch(globalValue({ _currentUser: { ..._currentUser, roles: [...resRoles] } }));
				}
			}
		} else {
			setBankTitle("پرداخت ناموفق");
			setBankMessage(response?.Message);
			setFloLocalInvoiceId(response?.Result?.followupcode);
		}
		setIsLoading(false);
	};
	const handleCallBankMellat = async () => {
		setIsLoading(true);
		const payload = {
			SaleOrderId: behpardakht?.SaleOrderId || "0",
			RefId: behpardakht?.RefId || "0",
			SaleRefrenceId: behpardakht?.SaleReferenceId || "0",
			ResCode: behpardakht?.ResCode || 0,
		};
		const response = await CallBackMellat(payload);
		if (response && !response?.HasError) {
			setFloLocalInvoiceId(response?.Result?.followupcode);
			setBankTitle("پرداخت موفق");
			setBankMessage(response?.Message);
			await delay(3000);
			let _currentUser = await queryCurrentUser();
			if (_currentUser) {
				let resRoles = await queryUserRoles();
				if (resRoles) {
					dispatch(globalValue({ _currentUser: { ..._currentUser, roles: [...resRoles] } }));
				}
			}
		} else {
			setBankTitle("پرداخت ناموفق");
			setBankMessage(response?.Message);
			setFloLocalInvoiceId(behpardakht?.RefId || 0);
		}
		setIsLoading(false);
	};
	return (
		<>
			<Modal
				className="modal-incress"
				centered
				width="25rem"
				closeIcon={<CloseCircleOutlined />}
				open={statusOpen}
				footer={<></>}
				onCancel={() => {
					setStatusOpen(false);
					callback("");
				}}>
				<Spin
					spinning={inPayment}
					tip={
						<>
							<div>لطفا چند لحظه منتظر بمانید</div>
						</>
					}>
					{isCallBack ? (
						<div className="holder-callback">
							<h3>{bankTitle}</h3>
							<p>{bankMessage}</p>
							<div className="holder-list-pay">
								<ul>
									<li>
										<div className="label">تاریخ و ساعت</div>
										<div className="value">{convertToJalaliWithTime(new Date().toISOString())}</div>
									</li>
									<li>
										<div className="label">کدپیگیری</div>
										<div className="value">{floLocalInvoiceId}</div>
									</li>
								</ul>
							</div>
							<div className="holder-button">
								<Button
									className="btn-normal"
									onClick={() => {
										setStatusOpen(false);
										callback("");
									}}>
									بازگشت
								</Button>
							</div>
						</div>
					) : (
						<div className="holder-incress-wallet">
							<h3>افزایش اعتبار</h3>
							<p>پس از افزایش اعتبار به صفحه پیش‌فاکتور باز خواهید گشت.</p>
							<Form form={frmCharge} onFinish={handleSubmit} layout="vertical">
								{bankList.length > 1 && (
									<>
										<Form.Item
											name="getway"
											rules={[
												{
													validator: (_, value) => {
														if (isEmpty(value) || value === 0) {
															return Promise.reject(t("validation.required"));
														}
														return Promise.resolve();
													},
												},
											]}
											label="نوع درگاه">
											<Select>
												{bankList.map((item, index) => (
													<Select.Option key={index} value={item.bankId}>
														{item.faBankName}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</>
								)}
								{listWallet.length > 1 ? (
									<Form.Item
										name="WalletType"
										rules={[
											{
												validator: (_, value) => {
													if (isEmpty(value) || value === 0) {
														return Promise.reject(t("validation.required"));
													}
													return Promise.resolve();
												},
											},
										]}
										label="نوع کیف پول">
										<Select>
											{listWallet.map((item, index) => (
												<Select.Option key={index} value={item.value}>
													{item.name}
												</Select.Option>
											))}
										</Select>
									</Form.Item>
								) : (
									<Form.Item name="WalletType" style={{ display: "none" }}>
										<Input style={{ display: "none" }} />
									</Form.Item>
								)}

								<Form.Item
									rules={[
										{ required: true, message: t("validation.required") },
										{
											validator: (_, value) => {
												let _regex = new RegExp(t("validation.regexDigitComma"));
												if (!_regex.test(value)) {
													return Promise.reject(t("validation.number"));
												}
												return Promise.resolve();
											},
										},
										{
											validator: (_, value) => {
												let amount = parseInt(value.replace(/,/g, ""));
												if (
													amount % parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) === 0 &&
													amount >= parseInt(process.env.REACT_APP_MIN_CHARGE_BANK)
												) {
													return Promise.resolve();
												} else {
													return Promise.reject(t("validation.charge_bank_min"));
												}
											},
										},
									]}
									name="charge"
									label="مبلغ شارژ">
									<Input onInput={handleComma} dir="ltr" addonAfter="تومان" placeholder="مبلغ دلخواه" disabled={!activePrice ? disInput : false} />
								</Form.Item>
								{!activePrice && (
									<Form.Item label="مبلغ دلخواه" className="label-check">
										<Checkbox className="just-check" onChange={(e) => (e.target.checked === true ? setDisInput(false) : setDisInput(true))} />
									</Form.Item>
								)}

								<br />
								<Form.Item>
									<Button className="btn-normal btn-aptel" danger htmlType="submit" type="primary">
										پرداخت
									</Button>
								</Form.Item>
							</Form>
						</div>
					)}
				</Spin>
			</Modal>
			<Loading isOpen={isLoading} text="" />
		</>
	);
};

export default IncressCharge;
